import { render, staticRenderFns } from "./BannerCreateEdit.vue?vue&type=template&id=51c93d77&scoped=true&"
import script from "./BannerCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BannerCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c93d77",
  null
  
)

export default component.exports